import { appConfig } from '../../configs/app-config';

import { API_VERSION } from '../../constants/api-constants';

import DefaultMetaFields from './DefaultMetaFields';
import DefaultMetaFieldsV2 from './DefaultMetaFieldsV2';

export const DefaultMetaFieldsWrapper = appConfig.apiVersion === API_VERSION.V2 ? DefaultMetaFieldsV2 : DefaultMetaFields;